import { useCallback } from 'react'

import { useAdvancedFiltersContext } from 'features/views/ListView/ListHeader/Filters/Advanced/hooks/useAdvancedFiltersContext'

import { useToolbarContext } from './useToolbarContext'

export function useToolbarActionsFiltersState() {
    const { isFiltersPaneOpen, setIsFiltersPaneOpen } = useToolbarContext()
    const { filters } = useAdvancedFiltersContext()

    const onClick = useCallback(() => {
        setIsFiltersPaneOpen((prev) => !prev)
    }, [setIsFiltersPaneOpen])

    const filterCount = filters.length
    const isActive = isFiltersPaneOpen

    return {
        onClick,
        filterCount,
        isActive,
    }
}
